/**
 * @generated SignedSource<<e4fc680cabb714864ae083662ea8e96f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StakingEventType = "REWARD" | "STAKE" | "UNSTAKE";
export type StakeInput = {
  assetAmount: any;
  assetId: string;
};
export type CreateUnstakeMutation$variables = {
  input?: StakeInput | null | undefined;
};
export type CreateUnstakeMutation$data = {
  readonly unstake: {
    readonly id: string;
    readonly type: StakingEventType;
  } | null | undefined;
};
export type CreateUnstakeMutation = {
  response: CreateUnstakeMutation$data;
  variables: CreateUnstakeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Stake",
    "kind": "LinkedField",
    "name": "unstake",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateUnstakeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateUnstakeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9fc44eb8db40506148876367336f6949",
    "id": null,
    "metadata": {},
    "name": "CreateUnstakeMutation",
    "operationKind": "mutation",
    "text": "mutation CreateUnstakeMutation(\n  $input: StakeInput\n) {\n  unstake(input: $input) {\n    id\n    type\n  }\n}\n"
  }
};
})();

(node as any).hash = "e138bc14cb233f5a9eb4b033b05c293c";

export default node;
